import { combineReducers } from '@reduxjs/toolkit';

// Export all reading slice modules
// Import individual slice reducers
import readingChildReducer, { ReadingState } from './readingSlice';
import readingSessionsReducer, { ReadingSessionsState } from './readingSessionsSlice';
import readingAnalyticsReducer, { ReadingAnalyticsState } from './readingAnalyticsSlice';

// Export all actions from individual slices
export * from './readingSlice';
export * from './readingSessionsSlice';
export * from './readingAnalyticsSlice';

// Export types from individual slices
export type { ReadingState } from './readingSlice';
export type { ReadingSessionsState } from './readingSessionsSlice';
export type { ReadingAnalyticsState } from './readingAnalyticsSlice';

// Combined state type
export interface CombinedReadingState {
    reading: ReadingState;
    sessions: ReadingSessionsState;
    analytics: ReadingAnalyticsState;
}

// Export reducers

const readingReducer = combineReducers({
    reading: readingChildReducer,
    sessions: readingSessionsReducer,
    analytics: readingAnalyticsReducer,
});

export default readingReducer; 